import React from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';

const Loading = ({ dimmer, loadingText, loaderProps }) => (
  <div style={{ minHeight: 500 }}>
    {dimmer && (
      <Dimmer active inverted>
        <Loader {...loaderProps}>{loadingText}</Loader>
      </Dimmer>
    )}
    {!dimmer && <Loader {...loaderProps}>{loadingText}</Loader>}
  </div>
);

Loading.defaultProps = {
  dimmer: true,
  loadingText: 'กำลังโหลด...',
  loaderProps: {},
};

export default Loading;
